import client from "api/client";

// GET /websites — paginated. Returns a normalized { items, total, hasMore }.
export const listWebsites = async ({ limit = 20, offset = 0 } = {}) => {
  const { data } = await client.get("/websites", {
    params: { limit, offset, sort_by: "created_at", sort_desc: true },
  });
  return { items: data.items ?? [], total: data.total ?? 0, hasMore: !!data.has_more };
};

export const getWebsite = async (id) => {
  const { data } = await client.get(`/websites/${id}`);
  return data;
};

export const createWebsite = async ({ name, domain, settings = {} }) => {
  const { data } = await client.post("/websites", { name, domain, settings });
  return data;
};

export const updateWebsite = async (id, updates) => {
  const { data } = await client.put(`/websites/${id}`, updates);
  return data;
};

export const deleteWebsite = async (id) => {
  await client.delete(`/websites/${id}`);
};

export const activateWebsite = async (id) => {
  await client.post(`/websites/${id}/activate`);
};

export const deactivateWebsite = async (id) => {
  await client.post(`/websites/${id}/deactivate`);
};
